"use strict";
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;
var reflow = function(node) {
    return node.scrollTop;
};
exports.reflow = reflow;
function getTransitionProps(props, options) {
    var timeout = props.timeout, easing = props.easing, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style;
    var _style_transitionDuration, _style_transitionTimingFunction;
    return {
        duration: (_style_transitionDuration = style.transitionDuration) !== null && _style_transitionDuration !== void 0 ? _style_transitionDuration : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style_transitionTimingFunction = style.transitionTimingFunction) !== null && _style_transitionTimingFunction !== void 0 ? _style_transitionTimingFunction : (typeof easing === "undefined" ? "undefined" : _type_of(easing)) === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}
